import type { ReactElement } from 'react'
import { AppShell } from '../components/AppShell.js'
import { Button } from '../components/ui/button.js'
import { Badge } from '../components/ui/badge.js'
import { useStep } from '../state/useStep.js'
import { activePersona } from '../lib/persona.js'

export const LandingScreen = (): ReactElement => {
  const { goto } = useStep()
  const p = activePersona()
  return (
    <AppShell
      title="Readiness assistant"
      footer={<Button size="xl" onClick={() => goto('appliance-status')}>Get Started</Button>}
    >
      <h1 className="mb-4">Let's make sure your kitchen is ready</h1>

      <div className="bg-muted rounded-2xl p-4 mb-5">
        <div className="flex gap-3">
          <img
            src="/demo/whirlpool-dishwasher.png"
            alt={p.order.appliance}
            className="w-16 h-16 rounded-xl object-contain bg-white"
          />
          <div>
            <div className="font-semibold">{p.order.appliance}</div>
            <div className="text-sm text-muted-foreground">Order #{p.order.number} · Est. install: {p.order.estimatedInstall}</div>
            <div className="text-sm text-foreground mt-2">{p.name}</div>
            <div className="text-sm text-muted-foreground">{p.address.line1}, {p.address.city}, {p.address.state} {p.address.zip}</div>
          </div>
        </div>
      </div>

      <div className="text-xs font-semibold tracking-wider text-primary uppercase mb-2">Your property</div>
      <div className="bg-primary/5 border border-primary/15 rounded-2xl p-4 mb-5">
        <div className="font-semibold">{p.property.type} · {p.property.floor}</div>
        <div className="text-sm text-muted-foreground">Built {p.property.yearBuilt} · {p.property.sqft.toLocaleString()} sq ft</div>
        <div className="text-xs text-muted-foreground mt-1">From county records</div>
      </div>

      <div className="text-xs font-semibold tracking-wider text-primary uppercase mb-2">Pre-filled from your home profile</div>
      <div className="space-y-2">
        {([
          ['Cabinet Width',  p.prefill.cabinetWidth],
          ['Countertop',     p.prefill.countertop],
          ['Flooring',       p.prefill.flooring],
        ] as const).map(([label, field]) => (
          <div key={label} className="flex items-center justify-between bg-muted rounded-xl p-3">
            <div>
              <div className="text-xs text-muted-foreground">{label}</div>
              <div className="font-semibold">{field.value}</div>
              <div className="text-xs text-muted-foreground">{field.source}</div>
            </div>
            <Badge variant="info">Pre-filled</Badge>
          </div>
        ))}
      </div>
    </AppShell>
  )
}
